import { reportError } from 'ha/helpers/bugsnag/reportError';
import {
  getUserId,
  getIsAliased,
  getUserIdAlias,
  getUserTraits,
  getAnalyticsUserData,
  getUserUUID,
} from 'ha/modules/AuthLogic/selectors';
import { identify, alias } from '@hbf/analytics';
import { getFeatureFlags } from 'ha/modules/FeatureFlags';

/**
 * @returns {import('ha/myredux/types').Thunk}
 */
export const identifyUser =
  () =>
  (dispatch, getState, { apiV2, analytics }) => {
    const state = getState();

    const userId = getUserId(state);

    if (!userId) {
      analytics.identifyUser();

      return;
    }

    const { rudderstackRockerboxIdentify, enableOAuthTokamak } =
      getFeatureFlags(state);
    const aliasId = getUserIdAlias(state);
    const data = getUserTraits(state);
    const userDataAnalytics = getAnalyticsUserData(state);
    const identifyPayload = {
      ...data,
      ...userDataAnalytics,
      idp: enableOAuthTokamak,
    };
    const userUUID = getUserUUID(state);

    if (getIsAliased(state)) {
      if (rudderstackRockerboxIdentify === 'on') {
        // Due to an issue in the Rockerbox integration, we need to send the UUID value for external_id & email attribute separately

        // this will change the cookies to the userUUID which will change the value of external_id attribute
        identify(userUUID, identifyPayload, {
          integrations: {
            All: false,
            Rockerbox: true,
          },
          context: {
            traits: {
              email: userUUID,
            },
          },
        });

        // resets the cookies back to, userid based cookies
        identify(aliasId, identifyPayload, {
          integrations: {
            All: true,
            Rockerbox: false,
          },
        });
      } else {
        identify(aliasId, identifyPayload);
      }

      analytics.identifyUser();
    } else {
      alias(aliasId);

      if (identifyPayload.idp !== 'on') {
        apiV2.updateUser(userId, { isAliased: true }).catch(reportError);
      }

      setTimeout(() => {
        if (rudderstackRockerboxIdentify === 'on') {
          // Due to an issue in the Rockerbox integration, we need to send the UUID value for external_id & email attribute separately

          // this will change the cookies to the userUUID which will change the value of external_id attribute
          identify(userUUID, identifyPayload, {
            integrations: {
              All: false,
              Rockerbox: true,
            },
            context: {
              traits: {
                email: userUUID,
              },
            },
          });

          // resets the cookies back to, userid based cookies
          identify(aliasId, identifyPayload, {
            integrations: {
              All: true,
              Rockerbox: false,
            },
          });
        } else {
          identify(aliasId, identifyPayload);
        }
        analytics.identifyUser();
      }, 2000);
    }
  };
